import { createAction as createSmartAction } from 'redux-smart-actions';

export const disconnect = createSmartAction('AccountActions/disconnect');
